(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
(function (global){
/*global _:true*/
'use strict';

// Set debug to false to disable all console.logs
var App = global.App = {
	debug: 			true,
	initialized: 	false,
	resizers: 		[]
};

var	$ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

// Turn of console.log for unsupportedbrowsers and when debug is set to false;
require('./modules/_console');


$( document ).ready(function() {
	console.log('Eenvoud Foundetion');
	//$('nav#main-nav a').smoothScroll({offset: -34});
	_.each(App.resizers, function(resizer) {
		resizer();
	});

	
});

$(window).load(function() {
	App.initialized = true;
	//console.log(App.initialized);
	
	_.each(App.resizers, function(resizer) {
		resizer();
	});

});

var resizeTimer;

$(window).resize(function() {
	clearTimeout(resizeTimer);
	resizeTimer = setTimeout(function() {
		_.each(App.resizers, function(resizer) {
			resizer();
		});
	},100);
});

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"./modules/_console":2}],2:[function(require,module,exports){
(function (global){
'use strict';

if (window.console && console.warn && global.App.debug === true) {
	console.warn('debug mode is ON, all console.log messages will be shown!');
}

if (window.console && console.log && global.App.initialized === false) {
	console.log( 'This Website was built using the Eenvoud Foundetion theme. For more information, visit: http://www.eenvoudmedia.nl'); 
}

// Avoid `console` errors in browsers that lack a console.
if (!(window.console && console.log && global.App.debug === true)) {
	(function() {
		var noop = function() {};
		var methods = ['assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error', 'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log', 'markTimeline', 'profile', 'profileEnd', 'markTimeline', 'table', 'time', 'timeEnd', 'timeStamp', 'trace', 'warn'];
		var length = methods.length;
		var console = window.console = {};
		while (length--) {
			console[methods[length]] = noop;
		}
	}());
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}]},{},[1])

